<template>
  <div class="subject-dist__edit-hours">
    <div class="subject-dist__edit-hours__header" :style="{'background-color': subject.color}">
      <h4>{{ subject.name }}, {{ getAllKlasses }}</h4>
      <div class="icon__bg-circle close-subject_edit" @click="$emit('close')">
        <span class="icon-cross2"></span>
      </div>
    </div>
    <div class="subject-dist__edit-hours__body">
      <h2 class="marg-20-bottom">{{ getAllKlasses }} {{ i18n[locale].has }} {{ subject.hours }}
        {{ i18n[locale].hours_in_school_year }}</h2>
      <div class="input-group">
        <label class="label--large">{{ i18n[locale].add_new_hours_for }} {{ teacher.name }}</label>
        <input type="number"
               ref="input_hours"
               v-model="hours"
               @focus="selectAll">
      </div>
      <div class="submit-buttons marg-20-top">
        <button @click="$emit('close')">{{ i18n[locale].cancel }}</button>
        <button class="submit-button marg-10-left" @click="submit">{{ i18n[locale].update }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import docendo from '../../docendo'

export default {
  props: {
    subject: {},
    teacher: {},
    task: { default: null }
  },
  data () {
    return {
      hours: '',
      i18n: {
        da: {
          add_new_hours_for: 'Indtast nyt timetal for',
          has: 'har',
          hours_in_school_year: 'Klokketimer i skoleåret',
          cancel: 'Annullér',
          update: 'Opdatér'
        },
        en: {
          add_new_hours_for: 'Enter new number of hours for',
          has: 'has',
          hours_in_school_year: 'hours in schoolyear',
          cancel: 'Cancel',
          update: 'Update'
        },
        nb: {
          add_new_hours_for: 'Angi nytt antall timer for',
          has: 'har',
          hours_in_school_year: 'timer i skoleåret',
          cancel: 'Avbryt',
          update: 'Oppdater'
        }
      }
    }
  },
  computed: {
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasksInHash () {
      return this.$store.getters.tasksInHash
    },
    isInUserCalendar () {
      if (this.task && this.task.in_user_calendar) return true
      if (this.subject && this.teacher &&
          this.subject.calendar_id === this.teacher.user_calendar_id) return true
      return false
    },
    getAllKlasses () {
      if (this.subject && this.subject.calendar_id && this.allCalendarsInHash[this.subject.calendar_id]) {
        return this.allCalendarsInHash[this.subject.calendar_id].name
      }
      if (this.task) return this.task.name
      return this.subject ? this.subject.name : ''
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    locale () {
      return this.$store.getters.locale
    },
    taskId () {
      return this.task ? this.task.id : null
    }
  },
  methods: {
    selectAll (event) {
      setTimeout(function () {
        event.target.select()
      }, 0)
    },
    submit () {
      const store = this.$store
      const schoolYearId = this.activeSchoolYear
        ? this.activeSchoolYear.id
        : (this.subject ? this.subject.school_year_id : null)
      const schoolId = this.subject ? this.subject.school_id : null
      const refreshSubjects = () => {
        if (!schoolYearId || !schoolId) return
        docendo.readSubjects(schoolId, schoolYearId, null, subjects => {
          store.commit('setSubjects', subjects)
        }, () => {})
      }

      if (this.isInUserCalendar) {
        if (this.tasksInHash[this.subject.id]) {
          docendo.updateTask(
            this.subject.school_id,
            this.subject.school_year_id,
            this.subject.id,
            this.subject.name,
            this.subject.color,
            this.hours,
            this.subject.default_duration,
            this.subject.preparation != null ? Number(this.subject.preparation) : null,
            this.subject.belongs_to_calendars || [],
            this.subject.user_calendars || [this.teacher.user_calendar_id],
            true,
            () => {
              refreshSubjects()
            },
            failure => {
              console.log('Something went wrong')
            }
          )
        } else {
          docendo.updateSubject(
            this.subject.id,
            this.subject.name,
            this.subject.color,
            this.subject.calendar_id,
            this.subject.calendar_ids,
            this.subject.default_duration,
            this.subject.preparation,
            this.hours,
            this.subject.subject_type,
            this.subject.school_id,
            this.subject.school_year_id,
            this.subject.subject_code,
            this.subject.away || false,
            false,
            null,
            null,
            null,
            () => {
              refreshSubjects()
            },
            failure => {
              console.log('Something went wrong')
            }
          )
        }
      } else {
        docendo.setHoursForTeacherOnSubject(this.subject.id, this.subject.school_id, this.subject.school_year_id, this.teacher.user_calendar_id, this.hours, success => {
          let succesObj = success
          succesObj['user_id'] = this.teacher.id
          store.commit('updateTeacherHoursOnSubject', success)
          refreshSubjects()
        }, failure => {
          console.log('Something went wrong')
        })
      }
      this.$emit('close')
    },
    getSubjectHours () {
      if (this.isInUserCalendar) {
        this.hours = this.subject && this.subject.hours != null ? this.subject.hours : ''
        return
      }

      let defaultHours = this.subject && this.subject.hours != null ? this.subject.hours : ''

      let calId = null
      if (this.teacher && this.teacher.user_calendar_id) {
        calId = this.teacher.user_calendar_id
      } else if (this.teacher && this.teacher.calendar_id) {
        calId = this.teacher.calendar_id
      }

      if (!calId || !this.subject || !this.subject.subject_calendars) {
        this.hours = defaultHours
        return
      }

      let found = false
      for (let i = 0; i < this.subject.subject_calendars.length; i++) {
        const sc = this.subject.subject_calendars[i]
        if (sc && sc.calendar_id === calId) {
          this.hours = sc.hours
          found = true
          break
        }
      }

      if (!found) this.hours = defaultHours
    }
  },
  mounted () {
    setTimeout(_ => {
      this.$refs.input_hours.focus()
    }, 500)
  }
}
</script>

<style>
.subject-dist__edit-hours__header {
  padding: 20px;
  border-radius: 4px 4px 0 0;
  position: relative;
}

.close-subject_edit {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #ffffff;
  font-size: 16px;
}

.subject-dist__edit-hours__header h4 {
  color: #ffffff;
  font-size: 16px;
}

.subject-dist__edit-hours__body {
  padding: 20px;
  width: 500px;
  border-radius: 0 0 4px 4px;
}

.submit-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.input-group label.label--large {
  font-size: 11px;
}

</style>



// WEBPACK FOOTER //
// SubjectsDistributionUserEditHours.vue?32fc10d4